import { fork } from 'redux-saga/effects';
import authSaga from './auth';
import paymentSaga from './payments';
import walletSaga from './wallet';
import projectSaga from './project';
import utilsSaga from './utils';
import userSaga from './users';
import partnersSaga from './partners';
import adminSaga from './admin';
import orgSaga from './org';
import teamsSaga from './teams.js';
import assetsSaga from './assets';
import inventoryLocationsSaga from './inventoryLocations';
import serviceRequestSaga from './service_request';
import chatSaga from './chat';

export default function* indexSaga() {
    yield fork(authSaga);
    yield fork(paymentSaga);
    yield fork(walletSaga);
    yield fork(projectSaga);
    yield fork(utilsSaga);
    yield fork(userSaga);
    yield fork(partnersSaga);
    yield fork(adminSaga);
    yield fork(orgSaga);
    yield fork(teamsSaga);
    yield fork(assetsSaga);
    yield fork(inventoryLocationsSaga);
    yield fork(serviceRequestSaga);
    yield fork(chatSaga);
}
